import { render, staticRenderFns } from "./signEvidence.vue?vue&type=template&id=462d4be5&scoped=true"
import script from "./signEvidence.vue?vue&type=script&lang=js"
export * from "./signEvidence.vue?vue&type=script&lang=js"
import style0 from "./signEvidence.vue?vue&type=style&index=0&id=462d4be5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462d4be5",
  null
  
)

export default component.exports